<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="450" persistent>
        <v-card class="success-dialog-card">
            <v-card-text class="text-center pa-6">
                <!-- Success Icon -->
                <div class="success-icon-wrapper mb-4">
                    <v-icon size="48" color="success">mdi-check-circle</v-icon>
                </div>
                
                <!-- Course Image -->
                <div class="success-course-image mb-4">
                    <v-img 
                        v-if="course" 
                        :src="course.image_url" 
                        height="120" 
                        width="200"
                        class="mx-auto rounded-lg"
                        cover
                    />
                </div>

                <!-- Success Message -->
                <h3 class="success-title mb-4">Thank You for Registering!</h3>
                <p class="success-message mb-6">
                    Your free trial request for <strong class="success-course-name">{{ course ? course.name : '' }}</strong> is being processed. You'll be matched with a suitable teacher shortly.
                </p>

                <!-- CTA Button -->
                <button class="success-cta-btn" @click="$emit('go-home')">
                    Go to Dashboard
                </button>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'EnrollmentSuccessDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        course: {
            type: Object,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped>
.success-dialog-card {
    border-radius: 12px !important;
    overflow: hidden;
}

.success-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.success-course-image {
    display: flex;
    justify-content: center;
}

.success-title {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 20px;
    color: #1E1E1E;
}

.success-course-name {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    color: #994C26;
}

.success-message {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: rgba(30, 30, 30, 0.64);
    line-height: 1.5;
    margin: 0;
}

.success-cta-btn {
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    background-color: #E79007;
    border: none;
    border-radius: 6px;
    padding: 12px 32px;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
    max-width: 200px;

    &:hover {
        background-color: #d18306;
    }
}
</style>

